

import { motion } from "framer-motion";

const contributors = [
  {
    colsRow: "col-start-1 row-start-2",
    pics: "/images/Debbie.jpg",
    name: "Debbie",
    position: "UI/UX",
    number: "after:content-['2']",
    borderColor: "border-[#BFBFBF]",
    afterBgColor: "after:bg-[#BFBFBF]",
  },
  {
    colsRow: "col-start-2 row-start-1",
    scale: "md:scale-125",
    pics: "/images/oyin.jpg",
    name: "Oyin",
    position: "Frontend Dev",
    number: "after:content-['1']",
    borderColor: "border-[#ffd500]",
    afterBgColor: "after:bg-[#ffd500]",
  },
  {
    colsRow: "col-start-3 row-start-2",
    pics: "/images/bukola.jpg",
    name: "Bukola",
    position: "UI/UX",
    number: "after:content-['3']",
    borderColor: "border-[#d98132]",
    afterBgColor: "after:bg-[#d98132]",
  },
];

const fabulousPairs = [
  { pics: "/images/ttt.jpg", name: "Tayo & Oyin", position: "Frontend Devs" },
  {
    pics: "/images/vaal.jpg",
    name: "Victor & Chidinma",
    position: "Frontend Devs",
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 }
};

const scaleUp = {
  hidden: { opacity: 0, scale: 0.8 },
  show: { opacity: 1, scale: 1 }
};

const slideIn = {
  hidden: { opacity: 0, x: -50 },
  show: { opacity: 1, x: 0 }
};

const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1 }
};

export default function HallOfFameSection() {
  return(
    <motion.section 
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-100px" }}
      className="mt-4 rounded-t-2xl p-4 py-12 bg-secondary"
    >
      <div className="container max-w-7xl mx-auto grid gap-6">
        <motion.h2 
          variants={slideIn}
          className="font-bold text-[clamp(2rem,1.714rem+1.429vw,3rem)] text-center"
        >
          Legends Only: Our <span className="text-primary">Community</span>{" "}
          Hall of Fame
        </motion.h2>

        <motion.div 
          variants={container}
          className="grid gap-6 text-center"
        >
          <div className="grid gap-4">
            <motion.h3 
              variants={item}
              className="text-[clamp(1.75rem,1.536rem+1.071vw,2.5rem)] text-primary font-bold"
            >
              Stars of the chat
            </motion.h3>
            <motion.p 
              variants={item}
              className="max-w-prose mx-auto"
            >
              These legends keep the energy alive and the conversations
              flowing. Meet our top 3 contributors whose commitment and
              vibes have helped shape this community.
            </motion.p>

            <motion.ul 
              variants={container}
              className="grid grid-cols-3 grid-rows-3 justify-between md:grid-rows-1 md:mt-6"
            >
              {contributors.map((data, index) => (
                <motion.li
                  key={index}
                  variants={scaleUp}
                  className={`col-span-1 ${data.colsRow} row-span-2 md:row-span-1 md:row-start-1`}
                >
                  <figure
                    className={`flex flex-col items-center gap-1 ${data.scale}`}
                  >
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      className={`w-20 h-20 md:w-32 md:h-32 rounded-full overflow-hidden border-8 ${data.borderColor} relative after:absolute ${data.number} ${data.afterBgColor} after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-4 after:h-4 after:flex after:items-center after:justify-center`}
                    >
                      <img
                        src={data.pics}
                        alt={data.name}
                        className="w-full h-full object-cover"
                      />
                    </motion.div>
                    <figcaption className="text-center">
                      <p className="font-semibold">{data.name}</p>
                      <p className="text-sm">{data.position}</p>
                    </figcaption>
                  </figure>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </motion.div>

        {/* Most Fabulous Pairs */}
        <motion.div 
          variants={container}
          className="grid md:grid-cols-[1fr_2fr] gap-4 text-left md:mt-6 lg:gap-12"
        >
          <motion.div 
            variants={slideIn}
            className="flex flex-col gap-4"
          >
            <h3 className="text-[clamp(1.75rem,1.536rem+1.071vw,2.5rem)] text-primary font-bold">
              Most Fabulous Pairs
            </h3>
            <p>
              Every event has its showstoppers — and these pairs turned
              heads and stole hearts. Here's to the finest male and female
              duos who brought charm, vibes, and unforgettable moments.
            </p>
          </motion.div>

          <motion.div 
            variants={container}
            className="grid grid-cols-2 gap-4"
          >
            {fabulousPairs.map((data, index) => (
              <motion.figure
                key={index}
                variants={item}
                whileHover={{ scale: 1.03 }}
                className="h-full max-h-[300px] relative overflow-hidden rounded-lg"
              >
                <img
                  src={data.pics}
                  alt={data.pics}
                  className="max-w-full w-full object-cover h-full"
                  loading="lazy"
                />
                <figcaption className="absolute bottom-0 w-full flex flex-col items-center text-secondary bg-primary py-2 text-sm">
                  <h4 className="font-semibold">{data.name}</h4>
                  <p>{data.position}</p>
                </figcaption>
              </motion.figure>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  )
}